import {HOMEAWAY, VRBO, CTA_LINK_HOMEAWAY,
    CTA_LINK_VRBO, CTA_BUTTON_TEXT, HOMEAWAY_SITE} from '../banner-defaults';

function getBrandName(travelerApp) {
    return travelerApp && travelerApp.toLowerCase() === HOMEAWAY.toLowerCase() ? HOMEAWAY : VRBO;
}

function getDownloadLinkBase(brandName) {
    return brandName.toLowerCase() === HOMEAWAY.toLowerCase() ? CTA_LINK_HOMEAWAY : CTA_LINK_VRBO;
}

function getDownloadLink(ctaLink, brandName, hav, xdid) {
    const downloadLinkBase = ctaLink ? ctaLink : getDownloadLinkBase(brandName);
    return `${downloadLinkBase}?hav=${hav}&source_visitor_id=${hav}&source_xdid=${xdid}`;
}

function getImgUrl(site) {
    return `https://csvcus.homeaway.com/rsrcs/cdn-logos/4.6.3/sitename/${site.toLocaleLowerCase()}/web/app-icon-rounded.png`;
}

function getSite(brandName) {
    return brandName === VRBO ? VRBO : HOMEAWAY_SITE;
}

function getButtonLabel(label) {
    return label ? label : CTA_BUTTON_TEXT;
}

const appBannerCtaLinks = {
    'vrbo': {
        'inbox': 'https://t.vrbo.io/rE2P1y0qQ3',
        'mytrips': 'https://t.vrbo.io/tpErRkuBt5',
        'homepage': 'https://t.vrbo.io/50uyc7ONY6',
        'serp': 'https://t.vrbo.io/vzOOWqKPq7'
    },
    'homeaway': {
        'inbox': 'https://t.hmwy.io/FERmK3HrD3',
        'mytrips': 'https://t.hmwy.io/EpaEUzEBt5',
        'homepage': 'https://t.hmwy.io/218P4iYNY6',
        'serp': 'https://t.hmwy.io/wwKd6WUPq7 '
    }
};

const appModalCtaLinks = {
    'vrbo': {
        'mytrips': 'https://t.vrbo.io/M19crbFV08',
        'confirmation': 'https://t.vrbo.io/CMAnLirhAab',
        'confirmation-above-share-trip': 'https://t.vrbo.io/Qdawaa6Dxbb',
        'confirmation-below-share-trip': 'https://t.vrbo.io/Qdawaa6Dxbb',
    },
    'homeaway': {
        'mytrips': 'https://t.hmwy.io/PftghSQV08',
        'confirmation': 'https://t.hmwy.io/eCqNC24aDab',
        'confirmation-above-share-trip': 'https://t.hmwy.io/mV1kEC0DObb',
        'confirmation-below-share-trip': 'https://t.hmwy.io/mV1kEC0DObb',
    }
};

const BOOKINGS = 'bookings';
const CONFIRMATION = 'confirmation';
const HOMEAWAY_AS_DISPLAY_STRING = 'HomeAway';
const HOMEPAGE = 'homepage';
const INBOX = 'inbox';
const MY_TRIPS = 'mytrips';
const SERP = 'serp';
const STAYUI = 'stayUi';
const VRBO_AS_DISPLAY_STRING = 'Vrbo';

export {
    BOOKINGS,
    CONFIRMATION,
    HOMEAWAY_AS_DISPLAY_STRING,
    HOMEPAGE,
    INBOX,
    MY_TRIPS,
    SERP,
    STAYUI,
    VRBO_AS_DISPLAY_STRING,
    appBannerCtaLinks,
    appModalCtaLinks,
    getButtonLabel,
    getBrandName,
    getDownloadLinkBase,
    getDownloadLink,
    getImgUrl,
    getSite,
};
